import { useRef, useState, useEffect } from "react";
import * as pdfjs from "pdfjs-dist";
import book from "./book.pdf";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

// Set up PDF.js worker (Required for Vite/React 19)
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function MediaReleases() {
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const canvasRef = useRef(null);
  const [pdfDoc, setPdfDoc] = useState(null);

  // Load PDF Document
  useEffect(() => {
    const loadingTask = pdfjs.getDocument(book);
    loadingTask.promise.then((pdf) => {
      setPdfDoc(pdf);
      setNumPages(pdf.numPages);
      renderPage(1, pdf);
    });
  }, []);

  // Render specific page to Canvas
  const renderPage = (pageNum, pdf = pdfDoc) => {
    if (!pdf || !canvasRef.current) return;

    pdf.getPage(pageNum).then((page) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
      page.render(renderContext);
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= numPages) {
      setPage(newPage);
      renderPage(newPage);
    }
  };

  const onPopupOpen = () => {
    setPage(1);
    // Slight delay to ensure canvas is in DOM
    setTimeout(() => renderPage(1), 100);
  };

  // Reusable Download Icon (Replaces raw SVG code)
  const DownloadIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );

  return (
    <div className="flex flex-col px-5 mt-20" dir="rtl">
      <div className="self-start text-5xl font-bold text-zinc-900">
        إصدارات إعلامية
      </div>

      <div className="mt-10 w-full">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-5">
          <div className="relative group">
            <button className="absolute top-3 right-3 invisible group-hover:visible opacity-60 bg-white py-2 px-3 rounded-sm shadow-lg z-10">
              <DownloadIcon />
            </button>

            <Popup
              trigger={
                <div className="cursor-pointer flex flex-col p-2 bg-white rounded-lg border border-zinc-300">
                  <img
                    loading="lazy"
                    src="https://s3-alpha-sig.figma.com/img/563e/a79c/8dee8933ca84ab488efff571e7ad9034..."
                    className="w-full aspect-square object-cover"
                    alt="Cover"
                  />
                  <div className="flex gap-3 justify-end p-2 mt-1 items-center">
                    <div className="text-sm font-medium text-zinc-800">
                      التبرعات الشهرية: الطريقة الاستدامية لدعم مشاريع الخير
                    </div>
                    <div className="bg-zinc-100 rounded p-1 shrink-0">
                      <DownloadIcon />
                    </div>
                  </div>
                </div>
              }
              onOpen={onPopupOpen}
              modal
            >
              {(close) => (
                <div className="relative flex flex-col items-center bg-zinc-900/90 p-5 rounded-xl shadow-2xl">
                  <button className="self-end text-white mb-2" onClick={close}>
                    ✕
                  </button>

                  {!pdfDoc && (
                    <span className="text-white">جاري التحميل...</span>
                  )}

                  <canvas
                    className="bg-white p-2 w-full max-w-2xl rounded-lg shadow-inner"
                    ref={canvasRef}
                  />

                  {pdfDoc && (
                    <nav className="mt-4 flex flex-row gap-3 items-center">
                      <div className="flex bg-white rounded-lg shadow-lg overflow-hidden">
                        <button
                          className="px-4 py-2 hover:bg-zinc-100 disabled:opacity-50"
                          disabled={page === numPages}
                          onClick={() => handlePageChange(page + 1)}
                        >
                          التالي
                        </button>
                        <span className="w-[1px] bg-zinc-300"></span>
                        <button
                          className="px-4 py-2 hover:bg-zinc-100 disabled:opacity-50"
                          disabled={page === 1}
                          onClick={() => handlePageChange(page - 1)}
                        >
                          السابق
                        </button>
                      </div>
                      <div className="text-white bg-zinc-800 px-3 py-2 rounded-lg">
                        {page} / {numPages}
                      </div>
                    </nav>
                  )}
                </div>
              )}
            </Popup>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MediaReleases;
